import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import QuickCashBanner from '../../../assets/personal-loan/quickcash-banner.png'
import AppGallery from '../../../assets/download/download_appgallery.png'
import GooglePlay from '../../../assets/download/download_googleplay.png'
import AppStore from '../../../assets/download/download_appstore.png'
import Logo from '../../../assets/download/logo_icon.png'
import { GOOGLE_PLAY_STORE_LINK, APP_STORE_LINK, APP_GALLERY_LINK } from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppQuickCash: React.FC = () => {
    const { t } = useTranslation()

    // ======================= GooglePlay
    const clickGooglePlay = () => {
        window.open(GOOGLE_PLAY_STORE_LINK)
    }

    // ======================= AppStore
    const clickAppStore = () => {
        window.open(APP_STORE_LINK)
    }

    // ======================= AppGallery
    const clickAppGallery = () => {
        window.open(APP_GALLERY_LINK)
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                paddingTop: '60px',
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Image src={QuickCashBanner} style={{borderRadius: '10px'}} alt='' preview={false}></Image>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: '6px',
                    paddingTop: '30px',
                }}>
                    <Typography fontSize={24} fontWeight={700} color={'#141F39'}>
                        {t('t209')}
                    </Typography>

                    <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'16px'}>
                        {t('t210')}
                    </Typography>

                    <Box sx={{
                        paddingTop: '20px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-start', 
                    }}>
                        <div style={{ 
                        flex: '0 0 50px', // 固定宽度
                        flexShrink: 0,      // 禁止压缩
                        }}>
                            <Image src={Logo} width={50} height={50} alt='' preview={false}></Image>
                        </div>
                        
                        <Box sx={{paddingLeft: '8px', flex: 1}}>
                            <Typography fontSize={16} fontWeight={600} color={'#141F39'}>
                                {t('t211')}
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: '16px'
                    }}>
                        <Box
                            onClick={clickGooglePlay}
                            sx={{
                                cursor: 'pointer',
                            }}>
                            <Image src={GooglePlay} width={133} height={40} alt='' preview={false}></Image>
                        </Box>

                        <Box sx={{
                            width: '10px'
                        }}></Box>

                        <Box
                            onClick={clickAppStore}
                            sx={{
                                cursor: 'pointer',
                            }}>
                            <Image src={AppStore} width={133} height={40} alt='' preview={false}></Image>
                        </Box>

                        <Box sx={{
                            width: '10px'
                        }}></Box>

                        <Box
                            onClick={clickAppGallery}
                            sx={{
                                cursor: 'pointer',
                            }}>
                            <Image src={AppGallery} width={133} height={40} alt='' preview={false}></Image>
                        </Box>
                    </Box>

                </Box>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMAppQuickCash
